import { render, staticRenderFns } from "./fullAmount.vue?vue&type=template&id=3b81ee43&scoped=true&"
import script from "./fullAmount.vue?vue&type=script&lang=js&"
export * from "./fullAmount.vue?vue&type=script&lang=js&"
import style0 from "./fullAmount.vue?vue&type=style&index=0&id=3b81ee43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81ee43",
  null
  
)

component.options.__file = "fullAmount.vue"
export default component.exports